// src/screens/ThankYouScreen.js
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { clearQRData } from "../services/localStorageService";

const ThankYouScreen = ({ onDone }) => {
  const location = useLocation();
  const claimSent = location.state?.claimSent;
  const limitReached = location.state?.limitReached;
  const [sessionComplete, setSessionComplete] = useState(false);

  const handleDone = () => {
    clearQRData();
    if (onDone) onDone();
    setSessionComplete(true);
  };

  if (sessionComplete) {
    return (
      <div className="screen-container">
        <div className="thank-you-container">
          <div className="thank-you-icon">✓</div>
          <h1 className="thank-you-title">You're All Set!</h1>
          <p className="thank-you-message">
            You can close this tab now.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="screen-container">
      <div className="thank-you-container">
        <div className="thank-you-icon">✓</div>
        <h1 className="thank-you-title">Thank You!</h1>
        <p className="thank-you-message">
          Your feedback has been recorded.
        </p>
        {limitReached && (
          <div
            style={{
              background: "#fff3e0",
              border: "1px solid #ffe0b2",
              borderRadius: "8px",
              padding: "16px",
              margin: "16px 0",
              textAlign: "center",
            }}
          >
            <p style={{ margin: "0 0 4px", fontWeight: "600", color: "#e65100" }}>
              Voucher limit reached
            </p>
            <p style={{ margin: 0, fontSize: "0.9rem", color: "#555" }}>
              You've reached the maximum number of vouchers for this event/campaign.
            </p>
          </div>
        )}
        {claimSent && !limitReached && (
          <div
            style={{
              background: "#e8f5e9",
              border: "1px solid #c8e6c9",
              borderRadius: "8px",
              padding: "16px",
              margin: "16px 0",
              textAlign: "center",
            }}
          >
            <p style={{ margin: "0 0 4px", fontWeight: "600", color: "#2e7d32" }}>
              Check your email!
            </p>
            <p style={{ margin: 0, fontSize: "0.9rem", color: "#555" }}>
              We've sent you an email with a link to claim your exclusive voucher.
              Click the link in the email to reveal your promo code.
            </p>
          </div>
        )}

        <button
          className="button"
          onClick={handleDone}
          style={{ maxWidth: "200px", margin: "16px auto 0" }}
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default ThankYouScreen;
